import { render, staticRenderFns } from "./TextLanguageSelect.vue?vue&type=template&id=3b5314f2&"
import script from "./TextLanguageSelect.vue?vue&type=script&lang=js&"
export * from "./TextLanguageSelect.vue?vue&type=script&lang=js&"
import style0 from "./TextLanguageSelect.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports